/* Meaningwave digital album page: streaming player + add-to-cart without leaving the page */
(function () {
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }

  function init(root) {
    if (root.dataset.mwaReady) return; root.dataset.mwaReady = '1';
    var audio = root.querySelector('[data-mwa-audio]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-mwa-track]')).filter(function (r) { return r.dataset.src; });
    var player = root.querySelector('[data-mwa-player]');
    var now = root.querySelector('[data-mwa-now]');
    var fill = root.querySelector('[data-mwa-fill]');
    var bar = root.querySelector('[data-mwa-bar]');
    var cur = root.querySelector('[data-mwa-cur]');
    var dur = root.querySelector('[data-mwa-dur]');
    var toggles = root.querySelectorAll('[data-mwa-toggle],[data-mwa-playall]');
    var idx = -1;

    function paint() {
      var playing = !audio.paused;
      rows.forEach(function (r, i) {
        r.classList.toggle('is-current', i === idx);
        var b = r.querySelector('[data-mwa-trackbtn]');
        if (b) b.classList.toggle('is-playing', i === idx && playing);
      });
      toggles.forEach(function (t) { t.classList.toggle('is-playing', playing); });
    }

    function load(i, autoplay) {
      if (i < 0 || i >= rows.length) return;
      idx = i;
      var r = rows[i];
      audio.src = r.dataset.src;
      now.textContent = String(r.dataset.n).padStart(2, '0') + ' · ' + r.dataset.title;
      player.hidden = false;
      fill.style.width = '0%'; cur.textContent = '0:00';
      if ('mediaSession' in navigator) {
        var img = root.querySelector('.mwa-hero__cover img');
        navigator.mediaSession.metadata = new MediaMetadata({
          title: r.dataset.title,
          artist: (root.querySelector('.mwa-artist') || {}).textContent || '',
          album: (root.querySelector('.mwa-title') || {}).textContent || '',
          artwork: img ? [{ src: img.currentSrc || img.src, sizes: '600x600', type: 'image/jpeg' }] : []
        });
      }
      if (autoplay) audio.play().catch(function () {});
      paint();
    }

    function toggle() {
      if (idx < 0) { load(0, true); return; }
      if (audio.paused) audio.play().catch(function () {}); else audio.pause();
    }

    toggles.forEach(function (t) { t.addEventListener('click', toggle); });
    rows.forEach(function (r, i) {
      var b = r.querySelector('[data-mwa-trackbtn]');
      var title = r.querySelector('.mwa-tr__t');
      function go() { if (i === idx) toggle(); else load(i, true); }
      if (b) b.addEventListener('click', go);
      if (title) title.addEventListener('click', go);
    });

    audio.addEventListener('play', paint);
    audio.addEventListener('pause', paint);
    audio.addEventListener('loadedmetadata', function () { dur.textContent = fmt(audio.duration); });
    audio.addEventListener('timeupdate', function () {
      var p = audio.duration ? audio.currentTime / audio.duration * 100 : 0;
      fill.style.width = p + '%'; cur.textContent = fmt(audio.currentTime);
      bar.setAttribute('aria-valuenow', Math.round(p));
    });
    audio.addEventListener('ended', function () { if (idx + 1 < rows.length) load(idx + 1, true); else { idx = -1; paint(); } });

    function seekTo(clientX) {
      var rect = bar.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      if (audio.duration) audio.currentTime = p * audio.duration;
    }
    bar.addEventListener('click', function (e) { seekTo(e.clientX); });
    bar.addEventListener('keydown', function (e) {
      if (!audio.duration) return;
      if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - 5); e.preventDefault(); }
    });

    if ('mediaSession' in navigator) {
      navigator.mediaSession.setActionHandler('play', function () { audio.play(); });
      navigator.mediaSession.setActionHandler('pause', function () { audio.pause(); });
      navigator.mediaSession.setActionHandler('previoustrack', function () { load(Math.max(0, idx - 1), true); });
      navigator.mediaSession.setActionHandler('nexttrack', function () { if (idx + 1 < rows.length) load(idx + 1, true); });
    }

    /* Add to cart in place; falls back to a normal form post if anything fails */
    var toast = root.querySelector('[data-mwa-toast]');
    var toastMsg = root.querySelector('[data-mwa-toastmsg]');
    var toastTimer;
    root.querySelectorAll('[data-mwa-buy]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        var label = btn.textContent;
        btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function (res) {
            var item = res.items && res.items[0];
            toastMsg.textContent = 'Added to cart: ' + (item ? (item.variant_title && item.variant_title.indexOf('Track') === 0 ? item.variant_title.split(': ').pop() : item.product_title.split(' | ')[0]) : 'item');
            toast.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.hidden = true; }, 6000);
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.querySelectorAll('#CartCount, #CartCountCavas, [data-cart-count], .site-header__cart-count > span').forEach(function (el) { el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
          })
          .catch(function () { form.submit(); })
          .finally(function () { btn.disabled = false; btn.textContent = label; });
      });
    });
  }

  /* Image gallery: thumbnails swap the big cover image; clicking the big image opens it full size */
  function initGallery(root) {
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mwa-thumb]'));
    var hero = root.querySelector('.mwa-zoom img');
    if (!thumbs.length || !hero) return;
    var cur = 0;
    function setHero(n) {
      cur = n;
      var t = thumbs[n];
      hero.removeAttribute('srcset'); hero.removeAttribute('sizes');
      hero.src = t.dataset.hero; hero.alt = t.dataset.alt || '';
      thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === n); x.setAttribute('aria-pressed', k === n ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { setHero(k); }); });
    var lb = root.querySelector('[data-mwa-lb]');
    if (!lb || typeof lb.showModal !== 'function') return;
    var img = lb.querySelector('[data-mwa-lbimg]'), count = lb.querySelector('[data-mwa-lbcount]');
    var i = 0;
    function show(n) {
      i = (n + thumbs.length) % thumbs.length;
      img.src = thumbs[i].dataset.full; img.alt = thumbs[i].dataset.alt || '';
      count.textContent = (i + 1) + ' / ' + thumbs.length;
    }
    root.querySelector('.mwa-zoom').addEventListener('click', function () { show(cur); if (!lb.open) lb.showModal(); });
    lb.addEventListener('close', function () { setHero(i); });
    lb.querySelector('[data-mwa-lbprev]').addEventListener('click', function () { show(i - 1); });
    lb.querySelector('[data-mwa-lbnext]').addEventListener('click', function () { show(i + 1); });
    lb.querySelector('[data-mwa-lbclose]').addEventListener('click', function () { lb.close(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') show(i + 1); if (e.key === 'ArrowLeft') show(i - 1); });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1); x0 = null; });
  }

  function boot() { document.querySelectorAll('.mwa').forEach(function (r) { init(r); if (!r.dataset.mwaGal) { r.dataset.mwaGal = '1'; initGallery(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
